import React, { useState } from "react";
import { HashLink } from "react-router-hash-link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import "./LpNavBar.css";
import { FaWhatsapp } from "react-icons/fa";

const LpMenu = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("");

  const showSidebar = () => {
    setSidebarOpen(true);
  };

  const hideSidebar = () => {
    setSidebarOpen(false);
  };

  const handleSectionClick = (section) => {
    setActiveSection(section);
    hideSidebar();
  };

  return (
    <>
      {/* DESKTOP MENU */}
      <div className="lpMenu-container">
        <ul className="lpMenu-list">
          <li>
            <HashLink
              smooth
              to="#home"
              className={activeSection === "home" ? "active-link" : ""}
              onClick={() => handleSectionClick("home")}
            >
              Home
            </HashLink>
          </li>
          <li>
            <HashLink
              smooth
              to="#verification-support"
              className={
                activeSection === "verification-support" ? "active-link" : ""
              }
              onClick={() => handleSectionClick("verification-support")}
            >
              Verification Support  
            </HashLink>
          </li>
          <li>
            <HashLink
              smooth
              to="#services"
              className={activeSection === "services" ? "active-link" : ""}
              onClick={() => handleSectionClick("services")}
            >
              Services
            </HashLink>
          </li>
          <li>
            <HashLink
              smooth
              to="#documents"
              className={activeSection === "documents" ? "active-link" : ""}
              onClick={() => handleSectionClick("documents")}
            >
              Documents
            </HashLink>
          </li>
          <li>
            <HashLink
              smooth
              to="#why"
              className={activeSection === "why" ? "active-link" : ""}
              onClick={() => handleSectionClick("why")}
            >
              Why Goodway
            </HashLink>
          </li>
          <li>
            <a href="https://api.whatsapp.com/send?phone=919148889444">
              <button>
                <FaWhatsapp className="lpMenu-ico" />
                Message Me
              </button>
            </a>
          </li>
        </ul>
        <div>
          <li className="respButton">
            <a href="https://api.whatsapp.com/send?phone=919148889444">
              <button>
                <FaWhatsapp className="lpMenu-ico" />
                Message Me
              </button>
            </a>
          </li>
        </div>
        {/* Hamburger icon (mobile) */}
        {/* <FontAwesomeIcon
          icon={faBars}
          className="lpMenu-hamIcon"
          onClick={showSidebar}
        /> */}
      </div>

      {/* MOBILE SIDEBAR */}
      <div className={`lpMenu-sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="lpMenu-sidebar-header">
          <h2>Menu</h2>
          <FontAwesomeIcon
            icon={faX}
            className="lpMenu-closeIcon"
            onClick={hideSidebar}
          />
        </div>
        <ul className="lpMenu-sidebar-links">
          <li>
            <HashLink
              smooth
              to="#home"
              className={activeSection === "home" ? "active-link" : ""}
              onClick={() => handleSectionClick("home")}
            >
              Home
            </HashLink>
          </li>
          <li>
            <HashLink
              smooth
              to="#verification-support"
              className={
                activeSection === "verification-support" ? "active-link" : ""
              }
              onClick={() => handleSectionClick("verification-support")}
            >
              Govt Approved
            </HashLink>
          </li>
          <li>
            <HashLink
              smooth
              to="#services"
              className={activeSection === "services" ? "active-link" : ""}
              onClick={() => handleSectionClick("services")}
            >
              Services
            </HashLink>
          </li>
          <li>
            <HashLink
              smooth
              to="#documents"
              className={activeSection === "documents" ? "active-link" : ""}
              onClick={() => handleSectionClick("documents")}
            >
              Documents
            </HashLink>
          </li>
          <li>
            <HashLink
              smooth
              to="#why"
              className={activeSection === "why" ? "active-link" : ""}
              onClick={() => handleSectionClick("why")}
            >
              Why Goodway
            </HashLink>
          </li>
          <li>
            <a href="tel:9876543210">
              <button>
                <FaWhatsapp className="lpMenu-ico" />
                Call Us Now
              </button>
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default LpMenu;
